import { createSlice } from '@reduxjs/toolkit';

import { loadWidgetThunkAction } from '../../redux/load-widget-thunk';
import { EventRegistrationStatus } from '../purchase-tickets/purchase-actions';
import { User } from './authentication';
import { loadUserAsync, signOut } from './authentication-actions';

export interface AuthenticationSliceState {
  token: string | null;
  user: User | null;
  status: string;
  isRegisteredForEvent: boolean;
  isBlockedForEvent: boolean;
}

export const initialState: AuthenticationSliceState = {
  token: null,
  user: null,
  status: 'idle',
  isRegisteredForEvent: false,
  isBlockedForEvent: false,
};

const authenticationSlice = createSlice({
  name: 'authentication',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(loadUserAsync.pending, state => {
        state.status = 'loading';
      })
      .addCase(loadUserAsync.fulfilled, (state, { payload }) => {
        state.status = 'finished';
        state.token = payload.token;
        state.user = payload.user;
        state.isBlockedForEvent = payload.blocked;
        state.isRegisteredForEvent = payload.registered;
      })
      .addCase(loadUserAsync.rejected, state => {
        state.status = 'finished';
        state.token = null;
        state.user = null;
        state.isRegisteredForEvent = false;
        state.isBlockedForEvent = false;
      })
      .addCase(signOut, () => initialState)
      // TODO: [HL-1482] related to consolidation of authentication logic this may be refactored to remove duplication.
      .addCase(loadWidgetThunkAction.pending, state => {
        state.status = 'loading';
      })
      .addCase(loadWidgetThunkAction.fulfilled, (state, action) => {
        const {
          payload: { user, token, registrationStatus },
        } = action;

        state.user = user;
        state.token = token;
        state.status = 'finished';
        state.isRegisteredForEvent =
          registrationStatus !== EventRegistrationStatus.NOT_REGISTERED;
        state.isBlockedForEvent =
          registrationStatus === EventRegistrationStatus.BLOCKED;
      })
      .addCase(loadWidgetThunkAction.rejected, state => {
        state.status = 'finished';
      });
  },
});

// eslint-disable-next-line import/no-default-export
export default authenticationSlice.reducer;
